import Rollbar from "rollbar";

const baseConfig: Rollbar.Configuration = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  environment:
    process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV || "development",
  captureUncaught: true,
  captureUnhandledRejections: true,
  autoInstrument: {
    network: false,
    networkResponseHeaders: false,
    networkResponseBody: false,
    networkRequestBody: false,
    log: true,
    dom: true,
    navigation: true,
    connectivity: true,
  },
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || "dev",
        guess_uncaught_frames: true,
      },
    },
  },
};

// Client-side Rollbar instance (used in browser via RollbarProvider)
export const rollbarClientConfig: Rollbar.Configuration = {
  ...baseConfig,
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
};

// Server-side Rollbar instance (used in API routes)
let _serverInstance: Rollbar | null = null;

export function getServerRollbar(): Rollbar {
  if (!_serverInstance) {
    _serverInstance = new Rollbar({
      ...baseConfig,
      accessToken:
        process.env.ROLLBAR_SERVER_TOKEN ||
        process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
    });
  }
  return _serverInstance;
}
